<div class="szamlatomb-page ion-padding">
  <!-- Számlakibocsátó (a számlára és a NAV-ba kerülő adatok) -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Számlakibocsátó adatai</ion-card-title>
      <ion-card-subtitle>
        Ezek az adatok kerülnek a kiállított számla fejlécébe és a NAV adatszolgáltatásba (kibocsátó/eladó).
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <section class="settings-section">
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Cégnév" label-placement="stacked" fill="outline" [(ngModel)]="profil.cegnev"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Adószám (pl. 19310084-1-13)" label-placement="stacked" fill="outline" [(ngModel)]="profil.adoszam"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input label="Irányítószám" label-placement="stacked" fill="outline" [(ngModel)]="profil.irsz"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input label="Település" label-placement="stacked" fill="outline" [(ngModel)]="profil.telepules"></ion-input>
          </ion-col>
          <ion-col size="6" sizeMd="3">
            <ion-input label="Közterület neve" label-placement="stacked" fill="outline" [(ngModel)]="profil.kozterulet_nev"></ion-input>
          </ion-col>
          <ion-col size="3" sizeMd="2">
            <ion-input label="Jelleg (utca…)" label-placement="stacked" fill="outline" [(ngModel)]="profil.kozterulet_jelleg"></ion-input>
          </ion-col>
          <ion-col size="3" sizeMd="1">
            <ion-input label="Hsz." label-placement="stacked" fill="outline" [(ngModel)]="profil.hazszam"></ion-input>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-input label="Bankszámlaszám" label-placement="stacked" fill="outline" [(ngModel)]="profil.bankszam"></ion-input>
          </ion-col>
        </ion-row>
        <div class="series-actions">
          <ion-button color="primary" (click)="profilMent()" [disabled]="loading">
            <ion-icon slot="start" name="save"></ion-icon>
            Kibocsátó adatok mentése
          </ion-button>
        </div>
      </section>
    </ion-card-content>
  </ion-card>

  <!-- Tömb-szerepek (a checkout-os választó áthozva ide + storno/módosító) -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Tömb-szerepek</ion-card-title>
      <ion-card-subtitle>
        Itt állítod be, melyik számlatömb mire szolgál. A storno és a módosító (helyesbítő)
        bizonylatok <b>külön tömbökbe</b> kerülnek.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

      <section class="settings-section invoice-series-section">
        <h3>Tömb-szerepek</h3>
        <p class="section-help">
          A díjbekérő/számla beállítása korábban a Checkout fizetésnél volt – ide került át, kiegészítve
          a storno és módosító tömbökkel.
        </p>

        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-select interface="popover" label="Alapértelmezett díjbekérő tömb" label-placement="stacked"
              fill="outline" [(ngModel)]="config.default_proforma_tomb_id">
              <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ tombLabel(t) }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-select interface="popover" label="Alapértelmezett számlatömb" label-placement="stacked"
              fill="outline" [(ngModel)]="config.default_invoice_tomb_id">
              <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ tombLabel(t) }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-select interface="popover" label="Storno tömb" label-placement="stacked"
              fill="outline" [(ngModel)]="config.storno_tomb_id">
              <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ tombLabel(t) }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-select interface="popover" label="Módosító (helyesbítő) tömb" label-placement="stacked"
              fill="outline" [(ngModel)]="config.modosito_tomb_id">
              <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ tombLabel(t) }}</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col size="12" sizeMd="6">
            <ion-select interface="popover" label="Számviteli bizonylatok tömbje (nem NAV)" label-placement="stacked"
              fill="outline" [(ngModel)]="config.szamviteli_tomb_id">
              <ion-select-option [value]="''">— nincs (automatikus) —</ion-select-option>
              <ion-select-option *ngFor="let t of tombok" [value]="t.id">{{ tombLabel(t) }}</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>

        <div class="series-actions">
          <ion-button color="primary" (click)="configMent()" [disabled]="loading">
            <ion-icon slot="start" name="save"></ion-icon>
            Szerepek mentése
          </ion-button>
        </div>
        <ion-note color="medium" style="display:block; margin-top:8px; font-size:12px">
          Ha nincs storno/módosító tömb kijelölve, a rendszer automatikusan létrehoz egyet az első ilyen bizonylatnál.
        </ion-note>
      </section>
    </ion-card-content>
  </ion-card>

  <!-- Tömbök kezelése -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Számlatömbök</ion-card-title>
      <ion-card-subtitle>Számlaszám formátuma: <code>ELŐTAG-00001/ÉV</code>. A sorszám tömbönként évente 1-től indul – kivéve ha a <b>Folytonos</b> be van pipálva (akkor évek között folyamatos).</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <table class="tomb-tabla">
        <thead>
          <tr>
            <th>Név</th><th>Előtag</th><th>Formátum</th>
            <th>Storno</th><th>Módosító</th><th>Számviteli</th><th>Folytonos</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of tombok">
            <td><ion-input [(ngModel)]="t.nev"></ion-input></td>
            <td><ion-input [(ngModel)]="t.elotag"></ion-input></td>
            <td><ion-input type="number" [(ngModel)]="t.formatum"></ion-input></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="t.storno"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="t.modosito"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="t.szamviteli"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="t.folytonos"></ion-checkbox></td>
            <td style="white-space:nowrap">
              <ion-button size="small" color="success" (click)="ment(t)"><ion-icon slot="icon-only" name="save-outline"></ion-icon></ion-button>
              <ion-button size="small" color="danger" (click)="torol(t)"><ion-icon slot="icon-only" name="trash"></ion-icon></ion-button>
            </td>
          </tr>
          <tr>
            <td><ion-input placeholder="Új tömb neve" [(ngModel)]="uj.nev"></ion-input></td>
            <td><ion-input placeholder="ELŐTAG" [(ngModel)]="uj.elotag"></ion-input></td>
            <td><ion-input type="number" [(ngModel)]="uj.formatum"></ion-input></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="uj.storno"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="uj.modosito"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="uj.szamviteli"></ion-checkbox></td>
            <td style="text-align:center"><ion-checkbox [(ngModel)]="uj.folytonos"></ion-checkbox></td>
            <td><ion-button size="small" color="primary" (click)="hozzaad()"><ion-icon slot="icon-only" name="add"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
      <ion-note color="medium" style="display:block; margin-top:12px; font-size:12px">
        Egy tömb csak akkor törölhető, ha még nincs hozzá bizonylat. A <b>Folytonos</b> sorszámozás évek között
        nem indul újra (számviteli bizonylathoz ajánlott); a NAV-os számláknál hagyd kikapcsolva.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
